// Add elements to external and affiliate links
document.addEventListener('DOMContentLoaded', function () {
  // Get the affiliate link symbol
  const symbol = window.SITE_CONFIG.affiliateLinkSymbol || '⟡'
  document.querySelectorAll('a').forEach((link) => {
    // Handle affiliate links
    if (
      link.classList.contains('affiliate') &&
      !link.querySelector('.affiliate-marker')
    ) {
      // Add rel sponsored
      link.setAttribute('rel', (link.getAttribute('rel') || '') + ' sponsored')
      // Add marker
      const marker = document.createElement('span')
      marker.className = 'affiliate-marker'
      marker.textContent = symbol
      link.appendChild(document.createTextNode('\u2009'))
      link.appendChild(marker)
    }

    // Handle external links (identified by target="_blank")
    if (
      link.target === '_blank' &&
      !link.classList.contains('button') &&
      !link.classList.contains('icon') &&
      !link.querySelector('.external-link-icon')
    ) {
      // Add external link icon
      const externalIcon = document.createElement('i')
      externalIcon.className =
        'external-link-icon fa-regular fa-arrow-up-right-from-square fa-xs'
      externalIcon.setAttribute('title', 'Opens in new tab')
      // Add space before icon
      link.appendChild(document.createTextNode('\u2009'))
      link.appendChild(externalIcon)
    }
  })
})
